import React from 'react';
import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const RubricItem = ({ text, bgColor, className }) => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={0} animateOnce={true} duration={1}>
            <div
                className={`rubric-item ${className ? className : ''}`}
                style={{ background: bgColor }}
            >
                {text}
            </div>
        </ScrollAnimation>
    );
};

export default RubricItem;
